module.exports = __webpack_public_path__ + "img/toolPic5.17881a06.png";